import {Vehicle} from '@nxcr-org/web-api-interface/lib/fleet_service_pb'
import {useMutation, UseMutationResult, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router'
import {FleetService} from '../../api/fleet-service'
import { VehicleDetailParams } from '../../fleet-management.types'
import {useState} from 'react'

export function useVehicleDetail(): UseVehicleDetails {
  const { id } = useParams<VehicleDetailParams>()
  const [displayDialogState, setDisplayDialogState] = useState({
    addRegistrationDialog: false,
    addDealDocumentsDialog: false
  })

  const queryClient = useQueryClient()

  const addDocumentMutation = useMutation({
    mutationFn: ( params: AddDocumentMutationParams ) => FleetService.addDocument({
      vin: vehicle.vin,
      vehicleId: vehicle.id,
      kind: params.kind,
      document: params.document
    }),
      onSuccess: () => {
        queryClient.invalidateQueries({queryKey: ['getVehicle', id]})
      }
    }
  )

  const {
    data: vehicle,
    isLoading
  } = useQuery({
    queryKey: ['getVehicle', id],
    queryFn: async () => {
      const response = await FleetService.getVehicleById(id)
      return response.vehicle
    }
  })

  return {
    vehicle,
    isLoading,
    displayDialogState,
    setDisplayDialogState,
    addDocumentMutation,
    setReload(){
      console.log('reload data n page pls...')
    }
  }
}

export interface Document {
  uploadDate: Date
  name: string
  url: string
  id: string
}

interface AddDocumentMutationParams {
  document: File,
  kind: string
}

interface UseVehicleDetails {
  vehicle: Vehicle.AsObject
  isLoading: boolean
  setReload: () => void
  displayDialogState: DisplayDialogState
  setDisplayDialogState: ( state: DisplayDialogState ) => void
  addDocumentMutation: UseMutationResult
}

interface DisplayDialogState {
  addRegistrationDialog: boolean
  addDealDocumentsDialog: boolean
}
// note: this is reusable, might want to move it elsewhere later on
export function formatVehicleState( state: number ): string {
  switch ( state ) {
    case 0:
      return 'In process'
    case 1:
      return 'In listing'
    case 2:
      return 'In order'
    case 3:
      return 'On subscription'
    case 4:
      return 'Charge off skip'
    case 5:
      return 'Pending return'
    case 6:
      return 'Return scheduled'
    case 7:
      return 'Return cancelled'
    case 8:
      return 'Off subscription'
    case 9:
      return 'Vehicle recycled'
    case 10:
      return 'Vehicle sold'
    case 11:
      return 'Repo eligible'
    case 12:
      return 'Out for repo'
    case 13:
      return 'Charge off eligible'
    default:
      return 'N/A'
  }
}
